import React, {useContext, useEffect, useState} from "react";
import { ResponsiveBar } from '@nivo/bar'
import '../../../styles/chart.css';
import {ViewContext} from "../../Context/ViewContext";

// Fonction de formatage des valeurs
const formatValue = (value, isPercentage, isNormal) => {
    if(!isPercentage && isNormal) {
        return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`;
    } else {
        return isPercentage ? `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}%` : `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}€`;
    }
};

export const BarChartCustom = ({data, dataBis, title, layout = "vertical", groupMode, keysArray = [], colors = "pastel1", width, height, isPercentage = false, fontSizeX = '11px', left = 60, labels={}, isNormal = false}) => {
    let keys = [];
    data.forEach(e => {
        keys.push(e.key)
    });
    const { view } = useContext(ViewContext)
    const {label, labelSecond} = labels;
    

    const getHeight = () => {
        if (view == "simple") {
            return height ? height : '300px';
        } else {
            return height ? '420px' : '450px';
        }
    };

    const commonBarProps = {
        keys: keysArray,
        indexBy: "key",
        layout: layout,
        margin: {top: 20, right: 100, bottom: 65, left: left},
        padding: 0.2,
        valueScale: {type: 'linear'},
        indexScale: {type: 'band', round: true},
        colors: {scheme: colors},
        groupMode: groupMode,
        height: (view == "simple") ? 250 : 160,
        label: ({value}) => formatValue(value, isPercentage, isNormal),
        tooltip: ({id, value, color, indexValue}) => (
            <div
                style={{
                    padding: '5px',
                    color: '#fff',
                    background: color,
                    borderRadius: '3px'
                }}
            >
                <strong>{indexValue}</strong> : {formatValue(value, isPercentage, isNormal)}
            </div>
        ),
        defs: [
            {
                id: 'dots',
                type: 'patternDots',
                background: 'inherit',
                color: '#38bcb2',
                size: 4,
                padding: 1,
                stagger: true
            },
            {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: '#eed312',
                rotation: -45,
                lineWidth: 6,
                spacing: 10
            }
        ],
        fill: [
            {
                match: {
                    id: 'fries'
                },
                id: 'dots'
            },
            {
                match: {
                    id: 'sandwich'
                },
                id: 'lines'
            }
        ],
        borderColor: {
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        },
        axisTop: null,
        axisRight: null,
        axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -30,
            legendPosition: 'middle',
            legendOffset: 85,
            truncateTickAt: 0,
        },
        axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendPosition: 'middle',
            legendOffset: -40,
            truncateTickAt: 0,
            format: value => formatValue(value, isPercentage, isNormal)
        },
        theme: {
            axis: {
                ticks: {
                    text: {
                        fontSize: fontSizeX,
                    }
                }
            }
        },
        labelSkipWidth:20,
        labelSkipHeight: 20,
        labelTextColor:'transparent',
        // labelTextColor: {
        //     from: 'color',
        //     modifiers: [
        //         [
        //             'darker',
        //             1.6
        //         ]
        //     ]
        // },
        legends: [
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 10,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 10,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ],
        role: "application",
        ariaLabel: "Nivo bar chart demo",
        barAriaLabel: e => e.id + ": " + e.formattedValue + " in country: " + e.indexValue
    };

    return (
        <div className="barContainer" style={{width: width ? width : '', height: getHeight()}}>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{textAlign: 'center'}}>{title}</span>
            <ResponsiveBar
                data={data}
                {...commonBarProps}
                axisBottom={{ ...commonBarProps.axisBottom, legend: label }}
            />
            <span style={{display: (view == "simple") ? 'none' : 'block', height: '100%'}}>
                <ResponsiveBar
                    data={dataBis}
                    {...commonBarProps}
                    axisBottom={{ ...commonBarProps.axisBottom, legend: labelSecond }}
                />
            </span>
            </div>
        </div>
    );
}



